export const fonts = {
  serif: "freight-display-pro, serif",
  sans: "lato, sans-serif",
  special: "lamar-pen, sans-serif",
};

export type ThemeFonts = typeof fonts;
